import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

import { routingConstants } from 'constants/routingConstants'
import ArrowDown from 'components/CommonUI/svgIcons/ArrowDown'
import { usePrevious } from 'custom-hooks'
import FacilityDropDownMenu from './FacilityDropDownMenu'

const FacilityMenu = () => {
  const { key, pathname } = useLocation()
  const [isOpenMenu, setIsOpenFasility] = useState(false)

  const prevKey = usePrevious(key)

  const handleClickFacility = () => {
    setIsOpenFasility((pr) => !pr)
  }

  useEffect(() => {
    if (key !== prevKey && isOpenMenu) {
      setIsOpenFasility(false)
    }
  }, [key, prevKey, isOpenMenu])

  return (
    <>
      <button
        className={`nav_item ${
          pathname.includes(routingConstants.facility) ||
          pathname.includes(routingConstants.equipment) ||
          isOpenMenu
            ? 'active'
            : ''
        }`}
        onClick={handleClickFacility}
      >
        <span className="nav_item_text">Facility</span>
        <ArrowDown className={isOpenMenu ? 'open' : ''} />
      </button>
      {isOpenMenu && (
        <ClickAwayListener
          onClickAway={handleClickFacility}
          mouseEvent="onClick"
        >
          <div>
            <FacilityDropDownMenu />
          </div>
        </ClickAwayListener>
      )}
    </>
  )
}

export default FacilityMenu
